export const environment = {
  production: false,
  scheme: 'https://',
  host: 'valfrescoapitest.valamar.com',
  port: ':7443',
  version: null,
};
